import { useAppStore } from "../../store/store";
import { useEffect } from "react";

export default function PortfolioDialog({
  portfolio,
  setPortfolio,
  recommendedPortfolioName,
}) {
  const portfolios = useAppStore((state) => state.formOptions.portfolios || []);

  // useEffect(() => {
  //   console.log("Portfolio Dialog - Available portfolios:", portfolios);
  //   console.log("Portfolio Dialog - Current selection:", portfolio);
  //   console.log("Portfolio Dialog - Recommended portfolio:", recommendedPortfolioName);
  // }, [portfolios, portfolio, recommendedPortfolioName]);

  function getPortfolioClass(id) {
    return portfolio === id
      ? "flex flex-col px-6 text-left text-gray-600 bg-as-green-0 border rounded-lg shadow-sm border-as-green-100 hover:border-as-green-100 hover:bg-as-green-0 active:border-as-green-100 active:bg-as-green-0 py-8"
      : "flex flex-col px-6 text-left border border-gray-300 rounded-lg shadow-sm bg-white hover:border-as-green-100 hover:bg-gray-50 active:border-as-green-100 active:bg-gray-50 py-8";
  }

  return (
    <>
      {portfolios.map((portfolioItem) => (
        <div
          key={portfolioItem.id}
          onClick={() => {
            console.log("Portfolio clicked:", portfolioItem.id);
            setPortfolio(portfolioItem.id);
          }}
          className={`cursor-pointer ${getPortfolioClass(portfolioItem.id)}`}
          role="button"
          tabIndex={0}
        >
          {recommendedPortfolioName === portfolioItem.name && (
            <div className="absolute text-xs font-bold leading-normal -translate-y-full text-as-green-100">
              Recommended
            </div>
          )}
          <h4 className="mb-3 text-lg font-bold text-gray-800">
            {portfolioItem.name}
          </h4>
          <p className="text-sm">{portfolioItem.description}</p>
          <ul className="mt-5 list">
            {portfolioItem.features?.map((feature, f_index) => (
              <li key={f_index} className="text-sm">
                {feature.feature}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}
